var F={50:"#FFFBED",100:"#FFFBED",200:"#FEF7DC",300:"#FDECA7",400:"#FCDF69",500:"#FBD94F",600:"#D5B843",700:"#B09837",800:"#7E6D28"};export{F as default};
